<template>
  <section class="content" style="background-color: #EBECF1">
    <div>
      <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true"></loading>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DEL PERSONAL</h3>
          </div>
          <div class="box-body">
            <form role="form">
              <div class="box-footer" style="padding-left:15px; display: flex; justify-content: space-between;">
                <button type="button" class="fuente btn btn-primary fs-13" data-toggle="modal" @click="limpiar()"
                  data-target="#modalNuevo">Nuevo Registro</button>
                <button type="button" class="fuente btn btn-success fs-13" @click="exportToExcel" style="margin-left: auto; margin-right:  20px; min-width: 200px; color: white; cursor: pointer; 
                  padding: 6px 15px; border: none; border-radius: 5px; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); align-items: center; transition: background-color 0.3s;" >
                  <i class="fab fa-microsoft" style="margin-right: 5px; font-size: 1.4em; color: white;"></i>                  
                  Descargar Excel
                </button>
              </div>
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="DNI" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">DNI</th>
                          <th aria-label="NOMBRE" aria-controls="tablaDetalle" tabindex="0" class="sorting_asc">NOMBRE
                          </th>
                          <th aria-label="CARGO" aria-controls="tablaDetalle" tabindex="0" class="sorting">CARGO</th>
                          <th aria-label="CORREO" aria-controls="tablaDetalle" tabindex="0" class="sorting">CORREO</th>
                          <th aria-label="NRO. CELULAR" aria-controls="tablaDetalle" tabindex="0" class="sorting">NRO.
                            CELULAR</th>
                          <th aria-label="JEFATURA" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">JEFATURA</th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">MODIFICAR
                          </th>
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">DETALLE</th>
                          <th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">ANULAR</th>
                          <th aria-label="PENSIONAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">PENSIONAR
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="item in trabs">
                          <td class="sorting_1">{{ item.cont }}</td>
                          <td>{{ item.dni }}</td>
                          <td>{{ item.nombres }} {{ item.apePaterno }} {{ item.apeMaterno }}</td>
                          <td>{{ item.cargo }}</td>
                          <td>{{ item.correo }}</td>
                          <td>{{ item.celular }}</td>
                          <td class="table-center-header">{{ item.jefatura }}</td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue"
                              data-toggle="modal" @click="ver(item)" data-target="#modalNuevo">O</span></td>
                          <td class="table-center-header">
                            <router-link :to="{ name: 'usuarios' /*, params: { idTrab: item.idTrabajador }*/ }"><span
                                @click="enviar(item)"
                                class="badge bg-yellow">V</span></router-link>
                          </td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-red"
                              data-toggle="modal" @click="verAnular(item)" data-target="#modalAnular">X</span></td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-grey"
                              data-toggle="modal" @click="verPensionar(item)" data-target="#modalPensionar">P</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error.desError }}
                  </div>
                </div>
              </div>

              <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">                                                 
                        <div class="row" style="position: relative;">
                          <div class="col-md-6">
                            N° de DNI (*)
                            <input type="text" class="form-control fuente m-t-10 m-b-10" required="true"
                              v-model="trab.dni" @input="handleDniInput" />
                            <span v-if="dniLengthError" class="formatMensajeError1">El DNI debe ser de 8 dígitos</span>
                          </div>
                          <div class="col-md-6">
                            Fecha de Nacimiento
                            <input type="date" class="form-control fuente m-t-10" required="true"
                              v-model="trab.fecNacimiento">
                          </div>
                          <div class="col-md-12 m-t-10">
                            Nombres (*)
                            <input type="text" class="form-control fuente m-t-10 m-b-10" required="true"
                              v-model="trab.nombres" @input="handleNombresInput" />
                          </div>
                          <div class="col-md-6">
                            Apellido Paterno (*)
                            <input type="text" class="form-control fuente m-t-10" required="true"
                              v-model="trab.apePaterno" @input="handleApePaternoInput" />
                          </div>
                          <div class="col-md-6">
                            Apellido Materno (*)
                            <input type="text" class="form-control fuente m-t-10" required="true"
                              v-model="trab.apeMaterno" @input="handleApeMaternoInput" />
                          </div>
                          <div class="col-md-6 m-t-10">
                            Cargo (*)
                            <input type="text" class="form-control fuente m-t-10" v-model="trab.cargo" />
                          </div>
                          <div class="col-md-6 m-t-10">
                            Anexo
                            <input type="number" class="form-control fuente m-t-10" v-model="trab.anexo" />
                          </div>
                          <div class="col-md-6 m-t-10">
                            Correo (*)
                            <div style="position: relative;">
                              <input type="email" class="form-control fuente m-t-10" required="true" v-model="trab.correo"
                                placeholder="example@tc.gob.pe" @input="handleCorreoInput" />
                              <span v-if="mensajeCorreoError" class="formatMensajeError2">{{ mensajeCorreoError }}</span>
                            </div>
                          </div>
                          <div class="col-md-6 m-t-10">
                            Nro. Celular
                            <input type="text" class="form-control fuente m-t-10" v-model="trab.celular" />
                          </div>
                          <div class="col-md-6 m-t-20">
                            Jefatura
                            <div class="m-t-10 m-l-10">
                              <input type="checkbox" v-model="trab.jefatura" true-value="1" false-value="" />
                            </div>
                          </div>
                          <div class="col-md-6 m-t-15">
                            Sigla
                            <input type="text" class="form-control fuente m-t-10" v-model="trab.sigla"
                              @input="handleSiglaInput" />
                            <small class="text-danger">{{ mensajeLimiteSigla }}</small>
                          </div>                          
                        </div>                                               
                      </div>                      
                      <div class="modal-footer">                        
                        <button type="button" class="fuente btn btn-primary fs-13" @click="merge()" data-dismiss="modal"
                          :disabled="isButtonDisabled || !trab.nombres || !trab.apePaterno || !trab.apeMaterno || !trab.cargo || !trab.correo"
                          :title="(isButtonDisabled || !trab.nombres || !trab.apePaterno || !trab.apeMaterno || !trab.cargo || !trab.correo) ? 'Para guardar, complete correctamente los campos requeridos (*)' : ''">Guardar
                          Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">Anular Trabajador</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anulará el siguiente trabajador: {{ trab.nombres }} {{ trab.apePaterno }} {{ trab.apeMaterno
                        }}<br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Anular Trabajador</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalPensionar" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">Pensionar Trabajador</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se pensionará al trabajador: {{ trab.nombres }} {{ trab.apePaterno }} {{ trab.apeMaterno
                        }}<br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Pensionar Trabajador</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

//require('moment')
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN, apiAUTH } from '@/store/state' //llamando al apiURL del store
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';
import * as XLSX from 'xlsx';

export default {
  name: 'Tables',
  data() {
    return {
      authorization: 'Bearer ' + localStorage.getItem('AccessToken'),
      trabs: [],
      texto: '',
      error: {
        desError: ''
      },
      trab: {
        idTrabajador: '0',
        nombres: '',
        apePaterno: '',
        apeMaterno: '',
        dni: '',
        cargo: '',
        anexo: '0',
        fecNacimiento: new Date().toISOString().split('T')[0],
        correo: '',
        celular: '',
        jefatura: '',
        sigla: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      config: {
        format: 'DD/MM/YYYY',
        useCurrent: false
      },
      dniLengthError: false,
      isButtonDisabled: true, /// deshabilitar el botón de Guardar del modal si el DNI ingresado es menor de 8 dígitos      
      tiempoActual: null,
      tiempoTokenExp: null,
      users: [],
      usersAuth: [],
      appById: [],
      areaById: [],
      rolById: [],
      trabs: [],
      trabs1: [],
      trabs2: [],
      allTrabs: [],
      AuthFilter: [],
      mensajeLimiteSigla: '',
      mensajeCorreoError: '', /// mensaje si el formato del input correo no es valido
      correoTimer: null, /// del método para validar que el formato del input correo sea valido
      isLoading: false,
      isButtonDisabled: false,
    }
  },
  components: {
    Loading
  },
  mounted() {
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    //this.tiempoActual = moment('18/6/2024, 9:46:36 a. m.', "D/M/YYYY, h:mm:ss a");
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a"); 
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");

    //console.log('fechaa actual:', this.tiempoActual, 'fecha tokenExp', this.tiempoTokenExp)

    // Verificar la sesión token
    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Realizar la validación con la API
      axios.get(`${apiLOGIN}/operaciones/app/GESU/personal`)
        .then(response => {
          if (response.data.codError === 1 || response.data.desError === 'ok') {
            // La validación es exitosa, continuar con la carga de datos
            this.carga();
          } else {
            //console.log("Usuario No Autorizado")
            //this.$router.go(-1);
            this.alertaError();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            //this.$router.go(-1);
            this.alertaError401();
          } else if (error.response && error.response.status === 403) {
            //this.$router.go(-1);
            this.alertaError();
          } else if (error.response && error.response.status === 500) {
            //this.$router.go(-1); 
            this.alertaError500();
          } else {
            //this.$router.go(-1);
            this.alertaError401();
          }
        });
    } else {
      this.alertaError401();
    }
  },
  methods: {
    carga() {      
      this.isLoading = true;
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance = $('#tablaDetalle').DataTable();
      if (dataTableInstance) {
        dataTableInstance.destroy();
      }

      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/*'
        `${apiURL}/usuarios/*`
      ).then(response => {
        this.trabs = response.data

        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true, // Guarda el estado y la paginación de la tabla
            'stateSaveParams': function (settings, data) {
              data.length = 25; // Establece la longitud de la página
            },
            //lengthMenu: [10, 25, 50, 100], // Definir las opciones de registros por página
            //pageLength: 25, // Establecer el número de registros por página al iniciar
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'sZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por página',
              'sInfoEmpty': 'Mostrando 0 al 0 de 0 registros',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
        this.isLoading = false;
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.isLoading = false;
            App.methods.logout.call(this);
          }
        })
    },
    merge: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {

        //// Para anular: (en caso de haberse ejecutado verAnular o verPensionar)
        if (this.trab.flagActivo == '0' || this.trab.cargo == 'PENSIONISTA') {
          //console.log('mergeAnular', this.trab.idTrabajador)

          ////// 1) Obtener todos los usuarios de this.trab.idTrabajador
          axios.defaults.headers.common['Authorization'] = this.$session.get('token')
          axios.get(
            `${apiURL}/usuarios/trabajador/` + this.trab.idTrabajador
          ).then(response => {
            this.users = response.data

            //// 2) Si users no esta vacío, forEach a cada idUsuario obtenido 
            if (this.users.length > 0) {
              this.users.forEach(array1 => {


                ///// 3) Para anular las relaciones aplicacionxusuario y rolxusuario, buscar cada idAppXUsu e idRolxUsu
                axios.get(
                  `${apiURL}/aplicaciones/appById/` + array1.idUsuario
                ).then(response => {
                  this.appById = response.data
                  //console.log('appById', this.appById)

                  ////// 4) Si appById no esta vacío, realizar un forEach
                  if (this.appById.length > 0) {
                    this.appById.forEach(array2 => {
                      ////// 5) Primero anular cada relación rolxusuario, para ello buscar cada idRolXUsu
                      axios.get(
                        `${apiURL}/operaciones/rolByUsu/` + array1.idUsuario + '/' + array2.idApp
                      ).then(response => {
                        this.rolById = response.data
                        //console.log('rolById', this.rolById)

                        ////// 6) Si rolById no esta vacío, realizar un forEach y anular cada rolxusuario                        
                        if (this.rolById.length > 0) {
                          this.rolById.forEach(array3 => {
                            axios.post(
                              `${apiURL}/operaciones/rolByUsu/add`,
                              {
                                'idUsuario': array1.idUsuario,
                                'idRol': array3.idRol,
                                'idRolXUsu': array3.idRolXUsu,
                                'flagActivo': '0',
                                'usuario': this.$session.get('user')
                              }
                            ).then(response => {
                              this.error = response.data
                              ///// Se anula cada rolxusuario de este usuario                       
                            })
                              .catch(error => {
                                if (error.response && error.response.status === 401) {
                                  App.methods.logout.call(this);
                                }
                              })
                          })
                        }
                      })
                        .catch(error => {
                          if (error.response && error.response.status === 401) {
                            App.methods.logout.call(this);
                          }
                        })

                      /// 7) Y anular cada aplicacionxusuario
                      axios.post(
                        `${apiURL}/operaciones/appByUsu/add`,
                        {
                          'idUsuario': array1.idUsuario,
                          'idAppXUsu': array2.idAppXUsu,
                          'flagActivo': '0',
                          'usuario': this.$session.get('user')
                        }
                      ).then(response => {
                        this.error = response.data
                        //// Se anula cada relación aplicacionxusuario de este usuario
                      })
                        .catch(error => {
                          if (error.response && error.response.status === 401) {
                            App.methods.logout.call(this);
                          }
                        })
                    })
                  }
                })
                  .catch(error => {
                    if (error.response && error.response.status === 401) {
                      App.methods.logout.call(this);
                    }
                  })

                ///// 8) Para anular cada relación areaxusuario, buscar cada idAreaXUsu
                axios.get(
                  `${apiURL}/operaciones/areaByUsu/` + array1.idUsuario
                ).then(response => {
                  this.areaById = response.data
                  //console.log('areaById', this.areaById)

                  ////// 9) Si areaById no esta vacío, realizar forEach para anular a cada areaxusuario
                  if (this.areaById.length > 0) {
                    this.areaById.forEach(array4 => {
                      axios.post(
                        `${apiURL}/operaciones/areaByUsu/add`,
                        {
                          'idAreaXUsu': array4.idAreaXUsu,
                          'idUsuario': array1.idUsuario,
                          'flagActivo': '0',
                          'usuario': this.$session.get('user')
                        }
                      ).then(response => {
                        this.error = response.data
                        ///// Se anula cada relación areaxusuario de este usuario              
                      })
                        .catch(error => {
                          if (error.response && error.response.status === 401) {
                            App.methods.logout.call(this);
                          }
                        })
                    })
                  }
                })
                  .catch(error => {
                    if (error.response && error.response.status === 401) {
                      App.methods.logout.call(this);
                    }
                  })

                ///// 10) Anular cada Usuario Cas
                axios.post(
                  `${apiURL}/operaciones/usuario/add`,
                  {
                    'idUsuario': array1.idUsuario,
                    'nomUsuario': array1.nomUsuario,
                    'clave': array1.clave,
                    'idTrabajador': array1.idTrabajador,
                    'flagActivo': '0',
                    'usuario': this.$session.get('user')
                  }
                ).then(response => {
                  this.error = response.data
                })
                  .catch(error => {
                    if (error.response && error.response.status === 401) {
                      App.methods.logout.call(this);
                    }
                  })
              });

              //// 11) Anular el usuarioAuth, para ello usar el primer registro de this.users y obtener el user_id del apiAUTH
              this.usersAuth = this.users[0]
              //console.log('usersAuth', this.usersAuth)

              if (this.usersAuth && this.usersAuth.nomUsuario) {
                axios.defaults.headers.common['Authorization'] = this.authorization
                //axios.get('https://tcperu.auth0.com/api/v2/users?per_page=100&page=0&search_engine=v3'
                axios.get(`${apiAUTH}/users?per_page=100&page=0&search_engine=v3`
                ).then(response => {
                  this.trabs = response.data
                  axios.defaults.headers.common['Authorization'] = this.authorization
                  //axios.get('https://tcperu.auth0.com/api/v2/users?per_page=100&page=1&search_engine=v3'
                  axios.get(`${apiAUTH}/users?per_page=100&page=1&search_engine=v3`
                  ).then(response => {
                    this.trabs1 = response.data
                    axios.defaults.headers.common['Authorization'] = this.authorization
                    //axios.get('https://tcperu.auth0.com/api/v2/users?per_page=100&page=2&search_engine=v3'
                    axios.get(`${apiAUTH}/users?per_page=100&page=2&search_engine=v3`
                    ).then(response => {
                      this.trabs2 = response.data
                      this.allTrabs = this.trabs.concat(this.trabs1, this.trabs2)                      

                      // Filtrar allTrabs para obtener el array que su username sea igual al nomUsuario de this.usersAuth
                      this.AuthFilter = this.allTrabs.flat().find(usu => usu.username.toLowerCase() === this.usersAuth.nomUsuario.toLowerCase());                      

                      if (this.AuthFilter && this.AuthFilter.user_id) {
                        axios.defaults.headers.common['Authorization'] = this.authorization
                        //axios.delete('https://tcperu.auth0.com/api/v2/users/' + this.AuthFilter.user_id
                        axios.delete(`${apiAUTH}/users/` + this.AuthFilter.user_id
                        ).then(response => {
                          //// usuarioAUTH eliminado de apiAUTH   
                        })
                          .catch(error => {
                            if (error.response && error.response.status === 401) {                              
                              App.methods.logout.call(this);
                            }
                          })
                      }
                    })
                      .catch(error => {
                        if (error.response && error.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                  })
                    .catch(error => {
                      if (error.response && error.response.status === 401) {
                        App.methods.logout.call(this);
                      }
                    })
                })
                  .catch(error => {
                    if (error.response && error.response.status === 401) {
                      App.methods.logout.call(this);
                    }
                  })
              }
            } else { }
          })
            .catch(error => {
              if (error.response && error.response.status === 401) {
                App.methods.logout.call(this);
              }
            })
        }

        ////// Registrar, Modificar o terminar de Anular Personal
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/trab/add',
          `${apiURL}/operaciones/trab/add`,
          {
            'idTrabajador': this.trab.idTrabajador,
            'nombres': this.trab.nombres,
            'apePaterno': this.trab.apePaterno,
            'apeMaterno': this.trab.apeMaterno,
            'dni': this.trab.dni,
            'cargo': this.trab.cargo,
            'anexo': this.trab.anexo,
            'fecNacimiento': this.trab.fecNacimiento,
            'correo': this.trab.correo,
            'celular': this.trab.celular,
            'jefatura': this.trab.jefatura,
            'sigla': this.trab.sigla,
            'flagActivo': this.trab.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data          
          this.carga();
        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    ver: function (trab) {
      this.texto = 'ACTUALIZAR DATOS DEL PERSONAL'; 
      //// Convertir la jefatura de 'SI' a '1' y de 'NO' a null
      this.trab = this.convertirJefatura({ ...trab });
      this.error.desError = '';
      this.dniLengthError = false;
      this.mensajeLimiteSigla = '';
      this.mensajeCorreoError = '';
      this.isButtonDisabled = false;
      //console.log(this.trab)
    },
    verAnular: function (trab) {
      //this.trab = { ...trab }
      this.trab = this.convertirJefatura({ ...trab })
      this.trab.flagActivo = '0'
      this.error.desError = ''
    },
    verPensionar: function (trab) {
      //this.trab = { ...trab }
      this.trab = this.convertirJefatura({ ...trab })
      this.trab.cargo = 'PENSIONISTA'
      // Verificar si this.trab.jefatura es '1' antes de asignar 'null'
      if (this.trab.jefatura == '1') {
        this.trab.jefatura = 'null';
      }
      this.error.desError = ''
      //console.log('this.trab', this.trab)      
    },
    limpiar: function () {
      //console.log(this.trab)
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/*'
        `${apiURL}/usuarios/*`
      ).then(response => {
        this.trabs = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      this.texto = 'REGISTRAR DATOS DEL NUEVO PERSONAL'
      this.trab.idTrabajador = '0';
      this.trab.nombres = '';
      this.trab.apePaterno = '';
      this.trab.apeMaterno = '';
      this.trab.dni = '';
      this.trab.cargo = '';
      this.trab.anexo = '0';
      this.trab.fecNacimiento = new Date().toISOString().split('T')[0];
      this.trab.correo = '';
      this.trab.celular = '';
      this.trab.jefatura = '';
      this.trab.sigla = '';
      this.trab.flagActivo = '1';
      this.error.desError = '';
      this.dniLengthError = false;
      this.mensajeLimiteSigla = '';
      this.mensajeCorreoError = '';
      this.isButtonDisabled = true;
    },
    ///// Formato para mostrar fecha en la tabla
    formatDate(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1); // Sumar un día
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
    removeLettersDni(property) {
      // Eliminar letras, espacios en blanco y caracteres no deseados
      this.trab[property] = this.trab[property].replace(/[^0-9]/g, '');
      // Limitar la longitud del DNI a 8 dígitos
      this.trab[property] = this.trab[property].slice(0, 8);
    },
    validateDniLength() {
      this.isButtonDisabled = this.trab.dni.length < 8;
      //this.dniLengthError = this.trab.dni.length === 8;      
      // Reinicia el temporizador cada vez que se ingresa un nuevo dígito
      clearTimeout(this.dniLengthTimer);
      this.dniLengthTimer = setTimeout(() => {
        // Si el temporizador llega a su límite y el DNI no tiene la longitud adecuada, activa el mensaje temporal
        if (this.trab.dni.length < 8) {
          this.dniLengthError = true;
        } else {
          // Si se completan los 8 dígitos, desactiva el mensaje temporal                    
          this.dniLengthError = false;
        }
      }, 1000);
    },
    handleDniInput(event) {
      this.removeLettersDni('dni');
      this.validateDniLength();      
    },

    handleNombresInput(event) {
      ////Nombres en mayúsculas
      this.trab['nombres'] = event.target.value.toUpperCase();
      /////Solo letras y espacio en blanco
      this.trab['nombres'] = this.trab['nombres'].replace(/[^A-Za-z\s]/g, '');
      this.crearSigla()
    },
    handleApePaternoInput(event) {
      this.trab['apePaterno'] = event.target.value.toUpperCase();
      this.crearSigla()
    },
    handleApeMaternoInput(event) {
      this.trab['apeMaterno'] = event.target.value.toUpperCase();
      this.crearSigla()
    },
    convertirJefatura(trab) {
      if (trab.jefatura === 'SI') {
        trab.jefatura = '1';
      } else if (trab.jefatura === 'NO') {
        trab.jefatura = null;
      } else {
        trab.jefatura = trab.jefatura;
      }
      // Puedes agregar más transformaciones según tus necesidades
      return trab;
    },
    handleCorreoInput() {
      // Reinicia el temporizador cada vez que se ingresa un nuevo carácter
      clearTimeout(this.correoTimer);
      this.correoTimer = setTimeout(() => {
        if (!this.trab.correo.includes('@')) {
          this.mensajeCorreoError = "El correo debe tener un formato válido";
        } else {
          this.mensajeCorreoError = "";
        }
      }, 2000);
    },
    enviar(item) {      
      localStorage.setItem('userIdTrab', item.idTrabajador)
      this.$store.commit('enviarCorreo', item.correo)      
      //this.$router.push('/derivaciones/consultarReclamo');
      //this.$router.push('/trabajadores');
      this.$router.push('/personal');
      //console.log('item personal', localStorage.getItem('userIdTrab'), localStorage.getItem('userMail'))
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
        //this.$router.go(-1);
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
        this.$router.go(-1);
        //this.$session.destroy()
        //this.$router.push('/login')
      });
    },

    handleSiglaInput(event) {
      // Convertir a mayúsculas y verificar límite de caracteres
      this.formatToUpperCase('sigla', event);
      // Eliminar espacios en blanco y caracteres no deseados en el campo Sigla
      this.removeSpacesAndSpecialChars('sigla');
      this.verificarLimiteSigla();
    },
    //Para convertir en mayúscula el texto ingresado en cajas
    formatToUpperCase(property, event) {
      this.trab[property] = event.target.value.toUpperCase();
    },
    ///Eliminar espacios en blanco y algunos caracteres especiales
    removeSpacesAndSpecialChars(property) {
      this.trab[property] = this.trab[property].replace(/[^A-Za-z_\-\.]/g, '');
    },
    //// Limitar cant. máxima de caracteres en la caja de texto Sigla del modal Nuevo
    verificarLimiteSigla() {
      const MAX_CARACTERES = 6; // Definir el límite máximo de caracteres      
      // Obtener la sigla sin espacios en blanco al inicio y al final
      const siglaSinEspacios = this.trab.sigla.trim();
      // Verificar si la longitud excede el límite
      if (siglaSinEspacios.length > MAX_CARACTERES) {
        // Truncar la sigla a la longitud máxima permitida
        this.trab.sigla = siglaSinEspacios.slice(0, MAX_CARACTERES);
        // Mostrar el mensaje de límite
        this.mensajeLimiteSigla = `⚠️ Máximo de ${MAX_CARACTERES} caracteres permitidos`;
      } else {
        this.mensajeLimiteSigla = '';
      }
    },
    crearSigla() {
      // Obtener las primeras letras de cada palabra de los campos nombres, apePaterno y apeMaterno
      const nombres = this.trab.nombres.charAt(0).toUpperCase();
      const apePaterno = this.trab.apePaterno.charAt(0).toUpperCase();
      const apeMaterno = this.trab.apeMaterno.charAt(0).toUpperCase();
      // Concatenar las primeras letras de cada campo para formar la sigla
      this.trab.sigla = `${nombres}${apePaterno}${apeMaterno}`;
    },
    /*
    ///// Validar que en el campo correo del modal se ingrese el formato correcto con @
    validarCorreo: function () {
      // Expresión regular para validar formato de correo electrónico
      const regexCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Verificar si el correo cumple con el formato válido
      if (!regexCorreo.test(this.trab.correo)) {
        // Mostrar un mensaje de error o tomar la acción que consideres apropiada
        alert('Por favor, ingrese un correo electrónico válido.');
        // También puedes desactivar el botón de guardar u otra lógica de manejo de error
      }
    },
    */
    // Nueva función para exportar a Excel
    exportToExcel() {
      // Crea una nueva hoja de trabajo
      const workbook = XLSX.utils.book_new();
      //const worksheet = XLSX.utils.json_to_sheet(this.trabs);

      // Definir las columnas que deseas exportar
      const filteredData = this.trabs.map(item => ({
        ITEM: item.cont, // Item
        DNI: item.dni, // DNI
        //NOMBRES: `${item.nombres} ${item.apePaterno} ${item.apeMaterno}`, // Nombres completos
        Nombres: item.nombres, 
        Apellido_Paterno: item.apePaterno,
        Apellido_Materno: item.apeMaterno,
        Cargo: item.cargo, // Cargo
        Correo: item.correo, // Correo
        Celular: item.celular, // Celular
        Jefatura: item.jefatura, // Jefatura
        // Puedes agregar más campos aquí si es necesario
      }));

      // Convertir el arreglo filtrado a una hoja de Excel
      const worksheet = XLSX.utils.json_to_sheet(filteredData);



      // Establecer el ancho de las columnas
      const columnWidths = [
        { wch: 5 }, // Ancho para "Contenido"
        { wch: 10 }, // Ancho para "DNI"
        { wch: 28 }, // Ancho para "Nombres"
        { wch: 20 }, // Ancho para "Apellido Paterno"
        { wch: 20 }, // Ancho para "Apellido Materno"
        { wch: 30 }, // Ancho para "Cargo"
        { wch: 28 }, // Ancho para "Correo"
        { wch: 12 }, // Ancho para "Celular"
        { wch: 10 }, // Ancho para "Jefatura"
      ];
      worksheet['!cols'] = columnWidths; // Asignar anchos de columnas


      /*
      // Aplicar ajuste de texto a la columna "Cargo"
      const cargoColumnIndex = 5; // Índice de la columna "Cargo"
      const rowCount = filteredData.length;

      for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 1, c: cargoColumnIndex });
        worksheet[cellAddress].s = {
          alignment: {
            wrapText: true, // Habilita el ajuste de texto
          },
        };

        // Ajustar el alto de la fila (opcional)
        const height = Math.ceil(worksheet[cellAddress].v.length / 30) * 15; // Calcular el alto
        worksheet['!rows'] = worksheet['!rows'] || [];
        worksheet['!rows'][rowIndex + 1] = { hpx: height }; // Ajustar el alto de la fila
      }     
      */

      
      // Agregar la hoja de cálculo al libro
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');

      // Obtener la fecha actual en formato deseado
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('es-ES', { // Cambia 'es-ES' por tu configuración regional deseada
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      // Genera el archivo Excel y lo descarga
      XLSX.writeFile(workbook, `Reporte de Personal (${formattedDate}).xlsx`);
    }
   

  }
}
</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.datetime-picker input {
  height: 2em !important;
  border: 1px solid #fff !important;
}

.formatMensajeError1 {
  color: rgba(255, 0, 0, 0.925);
  position: absolute;
  bottom: -7px;
  left: 27px;
  font-size: 11px;
}

@media (max-width: 767px) {
  .formatMensajeError1 {
    bottom: -14px;
    left: 22px;
    font-size: 11px;
  }
}

.formatMensajeError2 {
  color: rgba(255, 0, 0, 0.925);
  position: absolute;
  bottom: -16px;
  left: 12px;
  font-size: 11px;
}

@media (max-width: 767px) {
  .formatMensajeError2 {
    left: 7px;
    bottom: -15px;
  }
}

</style>



// WEBPACK FOOTER //
// Trabajadores.vue?8ce93334